import React from 'react';

const BadgeVerification = ({ niveau, size = 'sm' }) => {
  if (!niveau || niveau === 0) return null;

  const badges = {
    1: { label: 'Profil Vérifié', color: '#3b82f6', icon: '✓' },
    2: { label: 'Identité Vérifiée', color: '#8b5cf6', icon: '✓✓' },
    3: { label: 'Pro Certifié', color: '#F5A623', icon: '★' }
  };

  const badge = badges[niveau];
  if (!badge) return null;

  const sizes = {
    xs: { px: 'px-1.5 py-0.5', text: 'text-xs', iconSize: '10px' },
    sm: { px: 'px-2 py-0.5', text: 'text-xs', iconSize: '11px' },
    md: { px: 'px-3 py-1', text: 'text-sm', iconSize: '12px' }
  };

  const s = sizes[size] || sizes.sm;

  return (
    <span
      style={{ background: badge.color, color: 'white' }}
      className={`inline-flex items-center gap-1 rounded-full font-bold ${s.px} ${s.text}`}
    >
      <span style={{ fontSize: s.iconSize }}>{badge.icon}</span>
      {badge.label}
    </span>
  );
};

export default BadgeVerification;